module.exports = __webpack_public_path__ + "img/zengsong.7ea450a7.png";